import { useMutation, useQueryClient } from '@tanstack/react-query';

import { resetMfa } from '../api/adminsApi';
import { ADMIN_ACCOUNTS_QUERY_KEY } from './useAdminAccounts';

// PARA-151, AC-7/AC-E7: сброс MFA другого admin-аккаунта. Как и в
// useDeactivateAdmin (PARA-114, AC-E4), при ошибке тоже переинвалидируем —
// устраняет рассинхронизацию списка (гонка/устаревшие данные, 422).
export function useMfaReset() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (adminId: number) => resetMfa(adminId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_ACCOUNTS_QUERY_KEY });
    },
  });
}
